module.exports = __webpack_public_path__ + "static/TTNormsPro-BoldItalic-0e908f7da8a63c50a7589861fc8cf0d9.woff";